import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import SubMenuSider from '../../../components/SubMenuSider'
import { Select, Icon, Button, Input, Upload, Modal, Form, Spin } from 'antd'
import { Constants } from '../../../Constants/Constants'
import axios from 'axios'
import { filter, find, last, uniq, remove, take, slice, sortBy, isNil, cloneDeep, concat, includes } from 'lodash';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
//const fileList = [];
// const props2 = {
//     action: '//jsonplaceholder.typicode.com/posts/',
//     listType: 'picture',
//     defaultFileList: [...fileList],
//     className: 'upload-list-inline',
// };
// function handleChange(value) {
//     //console.log(`selected ${value}`);
// }

class Newfeedback extends Component {
    constructor() {
        super();

        this.state = {
            visible: false,
            loading: false,
            submit_success: false,
            previewVisible: false,
            previewImage: '',
            fileList: [],
        }
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //console.log(values)
                this.handleOk(values)
            }
        });

    }

    handleOk = (values) => {
        this.setState({
            visible: false,
            loading: true
        });

        if (values.upload) {
            axios.get(Constants.BASE_URL + 'auth/token').then((tokenRes) => {
                let token = tokenRes.data;
                let tokenHeader = { 
                    headers: { 
                        "Authorization": "Bearer " + token
                    } 
                };

                let formData = new FormData();
                console.debug("handleOk-values", values);
    
                values.upload.fileList.forEach(attachment => {
                    formData.append(attachment.name, attachment.originFileObj);
                });
                const uploadConfig = cloneDeep(tokenHeader);
                uploadConfig.headers["Content-Type"] = "multipart/form-data";
                axios.post("api/FileApi/multiple", formData, uploadConfig).then(base64FileReps => {
                    console.debug("ObservationRequest.submit.sendFile", base64FileReps.data);
                    this.post_feedback(values, base64FileReps.data);
                });
            });
        } 
        else {
            this.post_feedback(values, [])
        }
    }

    post_feedback(values, images) {
        var page = this.props.location.state.page
        var payload = {
          "topic": values.topic,
          "detail": values.detail,
          "attachmentGuids": images.map(a => a.id)
        };
        axios.get(Constants.BASE_URL + 'auth/token').then((tokenRes) => {
            let token = tokenRes.data;
            axios.post(
                "api/Feedback/Create", 
                payload, {
                    headers: {
                        "Authorization": "Bearer " + token,
                    }
                }
            ).then((response) => {
                this.setState({
                    loading: false,
                    submit_success: true
                })
                setTimeout(() => this.props.history.push(page), 2000);
            });
        });
    }

    handleCancelComfirm = (e) => {
        this.setState({
            visible: false,
        });
    }

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    handleChange = ({ fileList }) => this.setState({ fileList })
    handleCancel2 = () => {
        this.setState({ submit_success: false });
    }

    render() {
        // const { foo } = this.props.location.state;
        // console.log(foo)
        const { previewVisible, previewImage, fileList } = this.state;
        var page = this.props.location.state.page
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
            </div>
        );
        return (
            <div>
                <ScrollToTop />
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">
                    <SubMenuSider title="New Feedback" path={page}>
                        <div style={{ padding: "10%" }}>
                            <Form onSubmit={this.handleSubmit}>
                                <div style={{ width: "100%" }}>
                                    Topic
                                    < FormItem
                                        {...formItemLayout}
                                        label=""
                                        style={{ width: "100%", marginTop: "5px" }}
                                    >
                                        {
                                            getFieldDecorator('topic', {
                                                rules: [{
                                                    required: true, message: 'Please select shift',
                                                }],
                                            })(
                                                <Select placeholder={<span><Icon type="star" theme="outlined" /> Topic </span>} style={{ width: "100%" }}>
                                                    <Option value="System Error">System Error</Option>
                                                    <Option value="Performance">Performance</Option>
                                                    <Option value="Other">Other</Option>
                                                </Select>
                                            )}
                                    </FormItem >

                                </div>


                                <div style={{ marginTop: "10px" }}>
                                    Detail
                                    < FormItem
                                        {...formItemLayout}
                                        label=""
                                        style={{ width: "100%", marginTop: "5px" }}
                                    >
                                        {
                                            getFieldDecorator('detail', {
                                                rules: [{
                                                    required: true, message: 'Please select shift',
                                                }],
                                            })(
                                                <TextArea placeholder="Your feedback is a gift." maxLength={2000}
                                                    autosize={{ minRows: 4, maxRows: 6 }}
                                                />
                                            )}
                                    </FormItem >
                                </div>
                                <div style={{ marginTop: "10px" }}>
                                    Image upload
                                    < FormItem
                                        {...formItemLayout}
                                        label=""
                                        style={{ width: "100%", marginTop: "5px" }}
                                    >
                                        {
                                            getFieldDecorator('upload', {
                                                rules: [{
                                                    required: false
                                                }],
                                            })(
                                                <Upload
                                                    listType="picture-card"
                                                    fileList={fileList}
                                                    onPreview={this.handlePreview}
                                                    onChange={this.handleChange}
                                                    className="picture-card"
                                                >
                                                    {fileList.length >= 4 ? null : uploadButton}
                                                </Upload>
                                            )}
                                    </FormItem >
                                </div>

                                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                                <Button htmlType="submit" style={{ width: "80px", height: "40px", fontSize: "16px", padding: "0", margin: "60px 0 5px 0", border: "none", backgroundColor: "rgb(0,152,139)", color: "white", float: "right" }}>
                                    Submit<Icon type="right" theme="outlined" />
                                </Button>
                            </Form>
                            <Modal
                                title="Confirmation"
                                visible={this.state.visible}
                                onOk={this.handleOk}
                                onCancel={this.handleCancelComfirm}
                            >
                                Once you submit, you will no longer be able to change your answers for this attempt.
                            </Modal>
                            <Modal
                                visible={this.state.submit_success}
                                title="Submit Success"
                                footer={null}
                                onCancel={this.handleCancel2}
                            >
                                <p>Thank You.</p>
                            </Modal>
                        </div>
                    </SubMenuSider>
                </Spin>
            </div>
        );
    }
}

const Feedback2 = Form.create()(Newfeedback);
export default Feedback2